import React, { useState, useEffect } from "react";
import { database } from "../firebase";
import { Helmet } from "react-helmet-async";
import { ref, get, child } from "firebase/database";
import { motion } from "framer-motion";

const getPartyColor = (party) => {
  switch (party) {
    case "Democratic Progressive Party [DPP]":
      return "#1b9431";
    case "Blue and White [BAW]":
      return "#04beef";
    case "Likud [LIK]":
      return "#1f5aa5";
    case "Independent (No Party)":
      return "#918978";
    case "NaN":
      return "transparent";
    default:
      return "#918978";
  }
};

const getStatusClass = (status) => {
  switch (status) {
    case "active":
      return "active";
    case "suspended":
      return "suspended";
    case "vacant":
      return "vacant";
    default:
      return "";
  }
};

const OpenParliamentMobile = ({ title, description }) => {
  const [parliament, setParliament] = useState(null);

  useEffect(() => {
    const fetchParliamentData = async () => {
      const dbRef = ref(database);
      try {
        const snapshot = await get(child(dbRef, "parliament"));
        if (snapshot.exists()) {
          setParliament(snapshot.val());
        }
      } catch (error) {
        console.error("Error fetching parliament data:", error);
      }
    };

    fetchParliamentData();
  }, []);

  if (!parliament) {
    return <div className="prl-loading">Loading...</div>;
  }

  return (
    <div className="prl-container">
      <Helmet>
      <title>{title || 'Parliament - EnbyBase Official Website'}</title>
    <meta name="description" content={description || 'Parliament of EnbyBase Alliance'} />
    <meta property="og:title" content={title || 'Parliament - EnbyBase Official Website'}/>
    <meta property="og:description" content={description || 'Parliament of EnbyBase Alliance'}/>
  </Helmet>
      <motion.h1 
        className="prl-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Parliament Overview
      </motion.h1>
      <motion.div 
        className="prl-speaker"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        style={{ borderLeft: `5px solid ${getPartyColor(parliament.speaker.party)}` }}
      >
        <h2>Speaker</h2>
        <h3><a href={`https://discord.com/users/${parliament.speaker.discordUserId}`} target="_blank" rel="noopener noreferrer">{parliament.speaker.nickname}</a></h3>
        <span className="prl-party-badge" style={{ backgroundColor: getPartyColor(parliament.speaker.party) }}>
          {parliament.speaker.party}
        </span>
        <br style={({paddingBottom: '15px'})}></br>
        <span className={`prl-status-badge ${getStatusClass(parliament.speaker.status)}`}>
        {parliament.speaker.status.charAt(0).toUpperCase() + parliament.speaker.status.slice(1)}
        </span>
      </motion.div>
      <div className="prl-members-grid">
        {Object.entries(parliament.members).map(([key, member]) => (
          <motion.div 
            key={key}
            className="prl-member-card"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: Math.random() * 0.5 }}
            style={{ borderLeft: `5px solid ${getPartyColor(member.party)}` }}
          >
            <h3>
            <a href={`https://discord.com/users/${member.discordUserId}`} target="_blank" rel="noopener noreferrer">{member.nickname}</a>
            </h3>
            <p>{member.party}</p>
            <span className={`prl-status-badge ${getStatusClass(member.status)}`}>
              {member.status.charAt(0).toUpperCase() + member.status.slice(1)}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default OpenParliamentMobile;
